import React from 'react';
import './components/Blog';
import Blog from './components/Blog';

function App() {
  return (
    <Blog />
  );
}

export default App;
